import { Box, Container, Skeleton } from '@mui/material';
import EditTeamMemberStyles from './EditTeamMember.style';

const EditTeamMemberSkeleton = () => (
  <Container maxWidth="lg">
    <Box className={EditTeamMemberStyles.skeleton}>
      <Skeleton variant="rectangular" height={50} />
      <Skeleton variant="rectangular" height={30} />
      <Skeleton variant="rectangular" height={100} />
    </Box>
  </Container>
);

export default EditTeamMemberSkeleton;
